// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iPx4","title":"styles_title__2kA4A"};